import { render, staticRenderFns } from "./CarFaxPaymentRequiredControl.vue?vue&type=template&id=28e4b476&scoped=true"
import script from "./CarFaxPaymentRequiredControl.vue?vue&type=script&lang=js"
export * from "./CarFaxPaymentRequiredControl.vue?vue&type=script&lang=js"
import "./CarFaxPaymentRequiredControl.vue?vue&type=style&index=0&id=28e4b476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e4b476",
  null
  
)

export default component.exports